export const ShareSettingsRepository = Symbol('ShareSettingsRepository');
